<mat-button-toggle-group
  [hideSingleSelectionIndicator]="true"
  [(ngModel)]="currentView"
  aria-label="View">
  <mat-button-toggle (click)="onViewAction(tpaView.group)" [value]="tpaView.group">
    <mat-icon>view_stream</mat-icon>
  </mat-button-toggle>
  <mat-button-toggle (click)="onViewAction(tpaView.detail)" [value]="tpaView.detail">
    <mat-icon>view_headline</mat-icon>
  </mat-button-toggle>
</mat-button-toggle-group>
